<template>
  <div class="c-upload" @click="openFileSelector">
    <template v-if="!url">
      <i class="add-icon" v-if="!percent"></i>
      <span v-else class="upload-percent">{{percent}}%</span>
    </template>
    <template v-else>
      <img class="preview-img" :src="url">
    </template>
    <input ref="input" @change="handleChange" type="file" class="upload-input">
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import ajax from './ajax'
  import Upyun from '../../utils/upyun'

  export default {
    name: 'c-upload',
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      action: {
        type: String,
        default: Upyun.actionUrl
      },
      httpRequest: {
        type: Function,
        default: ajax
      },
      onProgress: {
        type: Function
      },
      url: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        tempIndex: 0,
        reqs: {},
        percent: 0
      }
    },
    components: {},
    created () {
    },
    async mounted () {
      this.data = await Upyun.getUploadConfig()
    },
    beforeDestroy () {
    },
    methods: {
      openFileSelector () {
        this.$refs.input.click()
      },
      handleChange (event) {
        const files = event.target.files
        if (!files) return
        this.uploadFiles(files)
      },
      uploadFiles (files) {
        let postFiles = Array.prototype.slice.call(files)
        if (!this.multiple) {
          postFiles = postFiles.slice(0, 1)
        }
        if (postFiles.length === 0) {
          return
        }
        postFiles.forEach(rawFile => {
          this.onStart(rawFile)
          this.upload(rawFile)
        })
      },
      onStart (rawFile) {
        rawFile.uid = Date.now() + this.tempIndex++
//        let file = {
//          status: 'ready',
//          name: rawFile.name,
//          size: rawFile.size,
//          percentage: 0,
//          uid: rawFile.uid,
//          raw: rawFile
//        }
      },
      upload (rawFile) {
        this.$refs.input.value = null
        this.post(rawFile)
      },
      post (rawFile) {
        const {uid} = rawFile
        const options = {
          // headers: this.headers,
          // withCredentials: this.withCredentials,
          file: rawFile,
          data: this.data,
          filename: 'file',
          action: this.action,
          onProgress: e => {
            this.percent = Number(e.percent).toFixed(0)
            // this.onProgress(e, rawFile)
          },
          onSuccess: res => {
            this.$emit('update:url', Upyun.fullImgUrl(res.url))
            // this.onSuccess(res, rawFile)
            delete this.reqs[uid]
          },
          onError: e => {
            // this.onError(err, rawFile)
            delete this.reqs[uid]
          }
        }
        const req = this.httpRequest(options)
        this.reqs[uid] = req
        if (req && req.then) {
          req.then(options.onSuccess, options.onError)
        }
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?51b036cb